import React, { Fragment } from 'react';
import CardVacancy from '../../common/cards/CardVacancy';
import CardVacancyAlert from "../../common/cards/CardVacancyAlert";
import CardProductLoading from '~/components/common/cards/CardProductLoading';

/* Utilities */
import { trans } from '~/utilities';

export default function VacancyOverviewResults({ vacancies = [], isLoading = false, isMobile }) {
    const alertCardInsertIndex = isMobile ? 4 : 7;
    const loadingElements = isMobile ? 4 : 8;

    if (!isLoading && (!vacancies || vacancies.length === 0)) {
        return <p>{trans('app.vacancy_overview.no_result')}</p>;
    }

    if (isLoading) {
        return (
            <div className="row row--md-equalized gutters-0 gutters-md-4 row--bordered row--md-unbordered">
                {Array.from({ length: loadingElements }).map((_, index) => (
                    <div className="col-12 col-md-6 col-xl-4 col-xxl-3 col-xxxl-3" key={index}>
                        <CardProductLoading />
                    </div>
                ))}
            </div>
        );
    }

    const alertCard = vacancies.find(v => v.type === 'alert_card');

    return (
        <div className="row row--md-equalized gutters-0 gutters-md-4 row--bordered row--md-unbordered">
            {vacancies.map((vacancy, index) => {
                if (vacancy.type === 'alert_card') return null;

                return (
                    <Fragment key={index}>
                        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 col-xxxl-3">
                            <CardVacancy vacancy={vacancy} />
                        </div>
                        {alertCard && index === alertCardInsertIndex && (
                            <div className="col-12 col-md-6 col-xl-4 col-xxl-3 col-xxxl-3" key="alert-card">
                                <CardVacancyAlert vacancy={alertCard} />
                            </div>
                        )}
                    </Fragment>
                );
            })}
        </div>
    );
}
